import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Button } from "antd";
import Head from "../../../component/Head";
import Footer from "../../../component/Footer";
import "./style.scss";
export default () => {
  const [url, setUrl] = useState("/login/c_login");
  useEffect(() => {
    if (localStorage && localStorage.userType === "2") {
      const delete_sign = JSON.parse(localStorage.userInfo).delete_sign;
      if (delete_sign === 0) {
        setUrl("/creditorUser");
      } else {
        setUrl(`/institutionApply?status=${delete_sign}`);
      }
    }
  }, []);

  return (
    <div className={"institutionIndex-container"}>
      <Head currentIndex={5} />
      <div className={"institutionIndex-content"}>
        <div className={"banner"}></div>
        <div className={"pain-points"}>
          <div className={"serviceProviderIndex-mainTitle"}>
            <div> </div>
            <span className={"bold"}>用户痛点</span>
            <div> </div>
          </div>
          <div className={"pain-points-content container-1200"}>
            <img
              className={"pain-points-leftImg"}
              src="https://api.faeping.com/storage/uploads/20250407/1743993908097_img%EF%BC%8F%E7%94%A8%E6%88%B7%E7%97%9B%E7%82%B92x.png"
              alt=""
            />
            <div className={"pain-points-describe"}>
              <div>
                <img
                  src="https://api.faeping.com/storage/uploads/20250407/1743988339041_icon%EF%BC%8F%E7%83%AD%E9%97%A8%E6%90%9C%E7%B4%A2%E5%A4%87%E4%BB%BD%2032x.png"
                  alt=""
                />
                作为司法拍卖的申请执行人，您是否担心标的物流拍或以底价成交？在矩阵资产平台，您可以认领司法拍卖标的物进行营销推广。
              </div>
              <div>
                <img
                  src="https://api.faeping.com/storage/uploads/20250407/1743988339041_icon%EF%BC%8F%E7%83%AD%E9%97%A8%E6%90%9C%E7%B4%A2%E5%A4%87%E4%BB%BD%2022x.png"
                  alt=""
                />
                作为银行、信托、小贷公司、典当行、资产管理公司等机构债权人，您是否还在为抵押物的成交而担忧，矩阵资产平台可以帮您进行营销推广。{" "}
              </div>
            </div>
          </div>
        </div>
        <div className={"ourValue"}>
          <div className={"serviceProviderIndex-mainTitle"}>
            <div> </div>
            <span className={"bold"}>我们的价值</span>
            <div> </div>
          </div>
          <div className={"container-1200"}>
            <div className={"ourValue-title"}>
              <div>
                <span>大数据/精准匹配/尽在掌握</span>
              </div>
              <div>
                <span>多渠道/营销推广/专业分析</span>
              </div>
            </div>
            <ul className={"ourValue-content"}>
              <li>
                <img
                  src="https://api.faeping.com/storage/uploads/20250407/1743994046501_icon-%E6%84%8F%E5%90%91%E4%BA%BA%E7%BE%A42x.png"
                  alt=""
                />
                <div className={"ourValue-content-describe"}>
                  <div>意向客群</div>
                  <div>海量高净值潜在客户资源，寻求高价值投资机会。</div>
                </div>
              </li>
              <li>
                <img
                  src="https://api.faeping.com/storage/uploads/20250407/1743994046501_icon-%E8%90%A5%E9%94%80%E6%8E%A8%E5%B9%BF2x.png"
                  alt=""
                />
                <div className={"ourValue-content-describe"}>
                  <div>营销推广</div>
                  <div>
                    互联网及本地化优质推广渠道，增加标的物定向曝光，处置精准成交。
                  </div>
                </div>
              </li>
              <li>
                <img
                  src="https://api.faeping.com/storage/uploads/20250407/1743994046501_icon-%E7%B2%BE%E5%87%86%E5%8C%B9%E9%85%8D2x.png"
                  alt=""
                />
                <div className={"ourValue-content-describe"}>
                  <div>精准匹配</div>
                  <div>
                    分析资产特点，锁定潜在客户，结合购买需求，一键触达精准撮合。
                  </div>
                </div>
              </li>
              <li>
                <img
                  src="https://api.faeping.com/storage/uploads/20250407/1743994046501_icon-%E4%B8%93%E4%B8%9A%E5%88%86%E6%9E%902x.png"
                  alt=""
                />
                <div className={"ourValue-content-describe"}>
                  <div>专业分析</div>
                  <div>
                    专业营销团队，多维度分析客户需求、辅助用户决策、提升资产处置率。
                  </div>
                </div>
              </li>
              <li>
                <img
                  src="https://api.faeping.com/storage/uploads/20250407/1743994046501_icon%EF%BC%8F%E8%B5%84%E4%BA%A7%E5%89%96%E6%9E%902x.png"
                  alt=""
                />
                <div className={"ourValue-content-describe"}>
                  <div>资产剖析</div>
                  <div>
                    海量标的处置案例，积累丰富的标的物处置经验，快速锁定目标人群。
                  </div>
                </div>
              </li>
              <li>
                <img
                  src="https://api.faeping.com/storage/uploads/20250407/1743994046501__%202x.png"
                  alt=""
                />
                <div className={"ourValue-content-describe"}>
                  <div>专人服务</div>
                  <div>
                    根据资产特点，提供专业、贴心的服务顾问，提供解决方案，为资产的顺利处置出谋划策，全程跟踪资产动态。
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>
        <div className={"saleCase"}>
          <div className={"serviceProviderIndex-mainTitle"}>
            <div> </div>
            <span className={"bold"}>营销案例</span>
            <div> </div>
          </div>
          <ul className={"saleCase-content container-1200"}>
            <li className={"saleCase-item"}>
              <img
                className={"coverImg"}
                src="https://api.faeping.com/storage/uploads/20250407/1743995615249_lQLPJxFj0x8PCnPNBPjNBq6wKrdY4WAvuCMH1Sy2wmAqAA_1710_1272.png"
                alt=""
              />
              <div className={"saleCase-infos"}>
                <div className={"saleCase-item-title"}>
                杭州经济技术开发区保利东湾6幢1单元2901室  
                </div>
                <div className={"saleCase-item-price"}>
                  成 &nbsp;交 &nbsp;价：<span>¥4,700,000元</span>
                </div>
                <div className={"saleCase-item-time"}>
                  成交时间：22024/12/02 10:00:00
                </div>
              </div>
              <img
                className={"auction_status"}
                src="https://api.faeping.com/storage/uploads/20250407/1743994168438_icon-%E5%B7%B2%E6%88%90%E4%BA%A42x.png"
                alt=""
              />
            </li>
            <li className={"saleCase-item"}>
              <img
                className={"coverImg"}
                src="https://api.faeping.com/storage/uploads/20250407/1743995615249_lQLPJxbBKWcsSPPNBOzNBq6wIntrDSuu9NUH1S0_nl8VAA_1710_1260.png"
                alt=""
              />
              <div className={"saleCase-infos"}>
                <div className={"saleCase-item-title"}>
                滨江区西兴街道科技馆街626号寰宇商务中心2幢303室
                </div>
                <div className={"saleCase-item-price"}>
                  成 &nbsp;交 &nbsp;价：<span>¥3,771,111元</span>
                </div>
                <div className={"saleCase-item-time"}>
                  成交时间：2024/11/11 16:13:12
                </div>
              </div>
              <img
                className={"auction_status"}
                src="https://api.faeping.com/storage/uploads/20250407/1743994168438_icon-%E5%B7%B2%E6%88%90%E4%BA%A42x.png"
                alt=""
              />
            </li>
          </ul>
        </div>
        <div className={"institution-submit"}>
          <Button type={"primary"}>
            <Link to={url}>申请入驻</Link>
          </Button>
        </div>
      </div>
      <Footer />
    </div>
  );
};
